<template>

  <HeaderSection />

  <section id="formulario" class="bg-white py-12 space-y-4 text-gray-700" style="font-family: RedHatDisplay-VariableFont_wght;">
  <div class="container mx-auto px-4 max-w-6xl">
    <div class="flex justify-center items-center p-4 gap-24">
      <div id="paypal-container-YHN34XUFG8ZXL"></div>
      <div>
        <p class="font-bold">You can also make a transfer to this account.</p>
        Account Holder Name: JULIAN FELIPE EYZAGUIRRE VALDERRAMA<br>
        Account Number: 8338820651<br>
        Account Type: Checking<br>
        Routing Number: 026073150<br>
        Swift / BIC: CMFGUS33<br>
        Bank Name: Community Federal Savings Bank<br>
        Bank Address: 5 Penn Plaza, 14th Floor, New York, NY 10001, US
      </div>
    </div>
  </div>
</section>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HeaderSection from '@/components/HeaderSection.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'PagoSection',
  components: {
    HeaderSection
  },
  data() {
    return {
      completo: false,
      tipo: ''
    };
  },
  mounted() {
    const route = useRoute();
    this.tipo = route.params.tipo as string;

    this.loadPayPalScript();
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    loadPayPalScript() {
      if (document.getElementById("paypal-sdk")) {
        this.initializePayPal();
        return;
      }

      const script = document.createElement("script");
      script.id = "paypal-sdk";
      script.src =
        "https://www.paypal.com/sdk/js?client-id=BAAFIEb0rBWkBA0ox9LOPjYPV13EI1gnXvFEZQRLQbHp4jeAG_fSL-LpyDMVfmdI-UfNlG0ZABh3YMDkpI&components=hosted-buttons&disable-funding=venmo&currency=USD";
      script.onload = this.initializePayPal;
      document.body.appendChild(script);
    },
    initializePayPal() {
      if (window.paypal) {       
        window.paypal
          .HostedButtons({
            hostedButtonId: "YHN34XUFG8ZXL",
          })
          .render("#paypal-container-YHN34XUFG8ZXL");
      }
    }
  }
});
</script>